import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'page-404',
	styleUrls: ['404.component.scss'],
	templateUrl: '404.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {}
